<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('agro-sugestao') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('agro') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'agro-sugestao' })">{{
                                        $t('agro-sugestao')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? $route.params.id : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToList()"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!integracao && !isUpdate && permissao.create) ||
                                (!integracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-12">
                            <v-textarea
                                :id="generateId(1)"
                                ref="sugestaoField"
                                title="agro-sugestao"
                                placeholder="placeholder-preencha"
                                v-model="sugestao.descricao"
                                :rows="6"
                                :maxRows="6"
                                :disableTransform="true"
                                tooltipLabel="tooltip-sugestao"
                                tooltipPosition="is-top"
                                tooltipSize="is-small"
                                :disabled="cantEdit"
                                :required="true"
                                :maxlength="1000"
                            />
                        </div>
                        <div class="column is-2">
                            <v-input
                                :id="generateId(8)"
                                ref="idsugestaoconteudoerpInput"
                                v-model="sugestao.idsugestaoconteudoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                :disabled="isUpdate"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                :id="generateId(2)"
                                ref="origemSelect"
                                title="tipo-sugestao"
                                v-model="origemSelected"
                                :searchable="false"
                                :options="origemSelect"
                                :loading="origemLoading"
                                placeholder="selecione"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :required="true"
                                :invalid="origemSelected == null"
                                :mlLabels="true"
                                clearable
                            />
                        </div>

                        <div class="column is-4">
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <vss-select
                                        :id="generateId(3)"
                                        ref="usuarioSelected"
                                        title="usuario"
                                        label="nome"
                                        placeholder="todos"
                                        :options="usuarioSelect"
                                        v-model="usuarioSelected"
                                        :disabled="cantEdit"
                                        @search="loadUsuario"
                                        tooltipSize="is-small"
                                        tooltipPosition="is-top"
                                        clearable
                                    />
                                </div>
                                <div
                                    class="control padding-label padding-label-custom"
                                    v-if="permissaoCadastrarUsuario"
                                >
                                    <b-button
                                        @click="
                                            $router.push({
                                                name: 'usuario-gerenciar-new',
                                                query: {
                                                    tela: 'agro-sugestao-new',
                                                    id: $route.params.id,
                                                },
                                            })
                                        "
                                        icon-right="plus"
                                        v-tippy
                                        :title="$t('adicionar-usuario')"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="column is-2">
                            <vss-select
                                title="situacao"
                                :id="generateId(4)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="!isUpdate"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//Service
import SugestaoService from '@/services/agro/SugestaoService';
import ColaboradorService from '@/services/ColaboradorService';
//Validation
import SugestaoValidation from '@/services/validations/SugestaoValidation';
import Message from '@/models/Message';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';
import { TheMask } from 'vue-the-mask';

export default {
    components: {
        TheMask,
        HideInfo,
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('SUGESTAO'),
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('USUARIO'),
            service: new SugestaoService(this.$http, this.$router),
            serviceUsuario: new ColaboradorService(this.$http, this.$router),
            validations: new SugestaoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            sugestao: {
                idsugestaoconteudo: null,
                idsugestaoconteudoerp: null,
                descricao: null,
                origem: null,
                idusuario: null,
                usuario: {
                    id: null,
                    nome: null,
                },
                situacao: null,
            },
            isUpdate: false,
            cantEdit: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            origemSelect: [],
            origemSelected: null,
            origemLoading: false,
            usuarioSelect: [], // lista para pegar usuarioSelect cadastrados no sitema
            usuarioSelected: null,

            permissaoUsuario: null,
            permissaoCadastrarUsuario: null,
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-sugestao');
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-sugestao' },
            });
        } else {
            this.permissaoUsuario = this.hasPermissionAccess(
                'admin',
                'gerenciar-usuarios',
                'admin-gerenciar-usuarios'
            );
            this.permissaoCadastrarUsuario =
                this.permissaoUsuario.create && !this.usuarioIntegracao;
            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update;
                this.carregarDados();
            } else {
                // para carregar o  carregar o campo situacao
                this.situacoes[this.situacao];
                this.loadOrigem();
            }
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id)
                .then((value) => {
                    this.sugestao.idsugestaoconteudo = value.content.idsugestaoconteudo;
                    this.sugestao.idsugestaoconteudoerp = value.content.idsugestaoconteudoerp;
                    this.sugestao.descricao = value.content.descricao;
                    this.sugestao.origem = value.content.origem;
                    this.sugestao.situacao = value.content.situacao;
                    this.sugestao.uuid = value.content.uuid;
                    if (value.content.usuario.id != 0) {
                        this.sugestao.usuario.id = value.content.usuario.id;
                        this.sugestao.usuario.nome = value.content.usuario.nome;
                    }
                    this.situacao = this.situacoes[this.sugestao.situacao];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.loadUsuario('');
                    this.loadOrigem();
                    setTimeout(() => {
                        this.$emit('isChanged', false);
                    }, 300);
                    this.runValidations(true);
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        //Para fazer a listagem de usuarioSelect
        loadUsuario(q) {
            this.serviceUsuario
                .findListAssociated(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por Colaboradores. Termo: [${q}].`
                        );
                        this.usuarioSelect = [];
                    } else {
                        this.usuarioSelect = r.content.map((v) => {
                            return {
                                id: v.id,
                                nome: v.nome.toLocaleUpperCase(),
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por Colaboradores. Termo: [${q}].`, e);
                    this.usuarioSelect = [];
                })
                .finally((_) => {
                    if (this.isUpdate && this.sugestao.usuario.id != null) {
                        this.usuarioSelected = Object.assign({}, this.sugestao.usuario);
                        this.usuarioSelect.push(this.usuarioSelected);
                    }
                });
        },
        loadOrigem() {
            // para carregar a listagem da origem no cadastro
            this.origemLoading = true;
            this.service
                .findAllOrigens()
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por origens.`
                        );
                        this.origemSelect = [];
                    } else {
                        this.origemSelect = r.content.map((i) => {
                            return { id: i, label: i.toLocaleLowerCase() };
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por origens.`, e);
                    this.origemSelect = [];
                })
                .finally(() => {
                    if (!this.isNull(this.sugestao.origem)) {
                        this.origemSelected = this.origemSelect.filter((f) => {
                            return f.id == this.sugestao.origem;
                        })[0];
                    }

                    this.origemLoading = false;
                });
        },

        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
        },
        save() {
            this.isLoading = true;
            if (this.validations.validate(this.sugestao, this.$refs)) {
                let sugestaoTemp = Object.assign({}, this.sugestao);
                sugestaoTemp = this.mapTosave(sugestaoTemp);
                sugestaoTemp.origem =
                    this.origemSelected == null
                        ? 'ocorrenciageral_descricaogeral'
                        : this.origemSelected.id; //valida esse valor como  caso o usuario não selecione
                sugestaoTemp.situacao = this.situacao.id;
                sugestaoTemp.uuid = this.sugestao.uuid;
                sugestaoTemp.idusuario = this.usuarioSelected == null ? 0 : this.usuarioSelected.id;
                this.invalidIcon = false;
                this.isSaving = true;
                this.service
                    .save(sugestaoTemp)
                    .then((value) => {
                        if (value.content) {
                            let msg = 'msg-save-agro-sugestao';
                            if (this.sugestao.idsugestaoconteudo != null) {
                                msg = 'msg-edit-agro-sugestao';
                            }
                            this.$root.showMessage('success', msg);
                            this.redirectToList();
                        } else {
                            if (this.$t(value.message)) {
                                this.$root.showMessage('success', value.message, true);
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.runValidations();
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },

        redirectToList() {
            if (this.$route.query.tela) {
                let tempTela = null;
                let tempAba = null;
                if (this.$route.query.tela == 'retricao-forncedor') {
                    //aba de onde veio
                    tempTela = 'agro-cliente-politica-comercial-edit'; // rota da tela que vai voltar
                    tempAba = 'agro-safra'; // aba da tela que retorna
                } else {
                    tempTela = 'agro-safra';
                }
                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: { id: this.$route.query['id'] },
                        query: { abaSelecionada: tempAba },
                    });
                }, 1000);
            } else {
                this.$router.push({ name: 'agro-sugestao-list' });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
    .nome-input {
        width: 49.5%;
    }
    .razao-social-input {
        width: 49.5%;
    }
}
</style>
